import { useEffect } from 'react'
import Proptypes from 'prop-types'
import { StyledAudioContainer } from './styles'

const Audio = ({ part, partIndex }) => {
  useEffect(() => {
    const el = document.getElementById(`audio-${partIndex}`)

    const handlePreload = () => {
      if (el) {
        el.src = part.url
        el.loop = false
      }
    }

    if (el) {
      handlePreload()
    }

    return () => {
    }
  }, [part, partIndex])

  return (
    <StyledAudioContainer>
      <audio controls preload="auto" id={`audio-${partIndex}`}>
        <span>
          Your browser does not support the audio element. Contact us at magie@mysmartjourney.com if you need help.
        </span>
      </audio>
      {part.legend && part.legend.length > 0 && <legend>{part.legend}</legend>}
    </StyledAudioContainer>
  )
}

Audio.propTypes = {
  part: Proptypes.object,
  partIndex: Proptypes.number,
}

export default Audio